import { memo } from "react";

import { Localized, useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

import { useInstitutionSettings } from "../../contexts/InstitutionSettingsContext";

interface SmsTransactionalDisclosureDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  loading: boolean;
}

const SmsTransactionalDisclosureDialog = memo(
  ({
    isOpen,
    onClose,
    onAccept,
    loading,
  }: SmsTransactionalDisclosureDialogProps) => {
    const { l10n } = useLocalization();
    const institution = useInstitutionSettings();

    return (
      <Dialog
        isOpen={isOpen}
        onUserDismiss={loading ? () => {} : onClose}
        title={l10n.getString("sms-disclosure-transaction-title")}
        footer={
          <Row justifyContent="end" alignItems="center">
            <Row.Item shrink>
              <Button
                kind="plain"
                label={l10n.getString("button-cancel")}
                onClick={onClose}
                disabled={loading}
              />
            </Row.Item>
            <Row.Item shrink>
              <Button
                kind="primary"
                label={l10n.getString("button-accept")}
                onClick={onAccept}
                isLoading={loading}
                disabled={loading}
              />
            </Row.Item>
          </Row>
        }
      >
        <Localized
          id="sms-disclosure-transaction-opt-in"
          vars={{ institutionName: institution.long_name || "" }}
          elems={{
            privacyUrl: (
              <a
                href={institution.privacy_url || "#"}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
            termsUrl: (
              <a
                href={institution.terms_url || "#"}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        >
          <p />
        </Localized>
      </Dialog>
    );
  }
);

export default SmsTransactionalDisclosureDialog;
